import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/images/swiper-1.png'
import _imports_1 from '../assets/images/swiper-mobile-1.jpg'
import _imports_2 from '../assets/images/swiper-3.png'
import _imports_3 from '../assets/images/swiper-mobile-3.jpg'
import _imports_4 from '../assets/images/swiper-4.png'
import _imports_5 from '../assets/images/swiper-mobile-4.jpg'
import _imports_6 from '../assets/images/swiper-3-mobile.jpg'
import _imports_7 from '../assets/images/swiper-4-mobile.jpg'
import _imports_8 from '../assets/images/stop-icon.png'
import _imports_9 from '../assets/images/homeVideo-swiper-bg-1.png'
import _imports_10 from '../assets/images/homeVideo-swiper-bg-1-mobile.png'
import _imports_11 from '../assets/images/crown.png'
import _imports_12 from '../assets/video/01.mp4'
import _imports_13 from '../assets/images/homeVideo-swiper-bg-2.png'
import _imports_14 from '../assets/images/homeVideo-swiper-bg-2-mobile.png'
import _imports_15 from '../assets/video/02.mp4'
import _imports_16 from '../assets/images/homeVideo-swiper-bg-3.png'
import _imports_17 from '../assets/images/homeVideo-swiper-bg-3-mobile.png'
import _imports_18 from '../assets/video/03.mp4'
import _imports_19 from '../assets/images/scene-img-1.png'
import _imports_20 from '../assets/images/scene-img-2.png'
import _imports_21 from '../assets/images/scene-img-3.png'
import _imports_22 from '../assets/images/scene-img-4.jpg'
import _imports_23 from '../assets/images/ang-code.jpg'


const _withScopeId = n => (_pushScopeId("data-v-221b8972"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container" }
const _hoisted_2 = {
  key: 0,
  src: _imports_0,
  alt: "",
  class: "swiper-img"
}
const _hoisted_3 = {
  key: 1,
  src: _imports_1,
  alt: "",
  class: "swiper-img"
}
const _hoisted_4 = { class: "swiper-con" }
const _hoisted_5 = { class: "swiper-main" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "title-one" }, "3D结构光", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "title-two" }, "Nuwa-XB40/ X100/ HP60", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "title-three" }, "原深相机", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "title-four" }, [
  /*#__PURE__*/_createTextVNode(" 针对机器人相关应用进行优化"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("最大视角可达100°x70° ")
], -1))
const _hoisted_10 = { class: "tab-box" }
const _hoisted_11 = { class: "tab-two" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "更多信息", -1))
const _hoisted_13 = {
  key: 0,
  src: _imports_2,
  alt: "",
  class: "swiper-img"
}
const _hoisted_14 = {
  key: 1,
  src: _imports_3,
  alt: "",
  class: "swiper-img"
}
const _hoisted_15 = { class: "swiper-con" }
const _hoisted_16 = { class: "swiper-main" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "title-one" }, "3D结构光", -1))
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "title-two" }, "Lite系列", -1))
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "title-three" }, "智能门锁解决方案", -1))
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "title-four" }, [
  /*#__PURE__*/_createTextVNode(" 业界首款人脸识别&掌静脉二合一模组"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("多款极致创想解决方案 ")
], -1))
const _hoisted_21 = { class: "tab-box" }
const _hoisted_22 = { class: "tab-two" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "更多信息", -1))
const _hoisted_24 = {
  key: 0,
  src: _imports_4,
  alt: "",
  class: "swiper-img"
}
const _hoisted_25 = {
  key: 1,
  src: _imports_5,
  alt: "",
  class: "swiper-img"
}
const _hoisted_26 = { class: "swiper-con" }
const _hoisted_27 = { class: "swiper-main" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "title-one" }, "3D激光雷达", -1))
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "title-two" }, "Nuwa-Lidar 120/ 120C", -1))
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "title-three" }, "业界首款消费级面阵dToF产品", -1))
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "title-four" }, [
  /*#__PURE__*/_createTextVNode(" 创新避障导航二合一"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("工作距离范围广，水平超大视场角 ")
], -1))
const _hoisted_32 = { class: "tab-box" }
const _hoisted_33 = { class: "tab-two" }
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "更多信息", -1))
const _hoisted_35 = {
  key: 0,
  src: _imports_2,
  alt: "",
  class: "swiper-img"
}
const _hoisted_36 = {
  key: 1,
  src: _imports_6,
  alt: "",
  class: "swiper-img"
}
const _hoisted_37 = { class: "swiper-con" }
const _hoisted_38 = { class: "swiper-main" }
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "title-one" }, "3D结构光", -1))
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "title-two" }, "Lite系列", -1))
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "title-three" }, "智能门锁解决方案", -1))
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "title-four" }, [
  /*#__PURE__*/_createTextVNode(" 业界首款人脸识别&掌静脉二合一模组"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("多款极致创想解决方案 ")
], -1))
const _hoisted_43 = { class: "tab-box" }
const _hoisted_44 = { class: "tab-two" }
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "更多信息", -1))
const _hoisted_46 = {
  key: 0,
  src: _imports_4,
  alt: "",
  class: "swiper-img"
}
const _hoisted_47 = {
  key: 1,
  src: _imports_7,
  alt: "",
  class: "swiper-img"
}
const _hoisted_48 = { class: "swiper-con" }
const _hoisted_49 = { class: "swiper-main" }
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "title-one" }, "3D激光雷达", -1))
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "title-two" }, "Nuwa-Lidar 120/ 120C", -1))
const _hoisted_52 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "title-three" }, "业界首款消费级面阵dToF产品", -1))
const _hoisted_53 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "title-four" }, [
  /*#__PURE__*/_createTextVNode(" 创新避障导航二合一"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("工作距离范围广，水平超大视场角 ")
], -1))
const _hoisted_54 = { class: "tab-box" }
const _hoisted_55 = { class: "tab-two" }
const _hoisted_56 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "更多信息", -1))
const _hoisted_57 = { class: "initial-con" }
const _hoisted_58 = { class: "main-one" }
const _hoisted_59 = { class: "video-swiper-con" }
const _hoisted_60 = { class: "left-con" }
const _hoisted_61 = { class: "main-title-two" }
const _hoisted_62 = { key: 0 }
const _hoisted_63 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "explain-main-two" }, "安思疆科技致力于构建人工智能时代的3D感知基础设施。产品包括3D结构光和dToF Lidar等三维传感整体解决方案，可应用于手机、平板、PC、金融支付、智能家居、机器人、安防监控、智能驾驶、医疗及工业测量等众多领域，在线下零售、服务机器人、安防监控等市场已实现多项商用。致力于打造将光电、硬件与算法融合为一体的、全球领先的三维传感与智能硬件整体方案专家。", -1))
const _hoisted_64 = { class: "right-con" }
const _hoisted_65 = ["controls"]
const _hoisted_66 = ["controls"]
const _hoisted_67 = {
  key: 2,
  src: _imports_8,
  alt: "",
  class: "stop"
}
const _hoisted_68 = {
  key: 0,
  src: _imports_9,
  alt: "",
  class: "swiper-img"
}
const _hoisted_69 = {
  key: 1,
  src: _imports_10,
  alt: "",
  class: "swiper-img"
}
const _hoisted_70 = { class: "video-swiper-con" }
const _hoisted_71 = { class: "left-con" }
const _hoisted_72 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "crown-con" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_11,
    alt: ""
  }),
  /*#__PURE__*/_createElementVNode("p", { class: "title-one" }, "旗舰产品")
], -1))
const _hoisted_73 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "main-title" }, "VENUS lite S", -1))
const _hoisted_74 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "main-title" }, "3D结构光人脸识别模组", -1))
const _hoisted_75 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "link" }, "了解更多 >", -1))
const _hoisted_76 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("ul", { class: "explain-con" }, [
  /*#__PURE__*/_createElementVNode("li", { class: "explain-mian" }, [
    /*#__PURE__*/_createElementVNode("span", null, "金融支付级"),
    /*#__PURE__*/_createTextVNode("3D结构光人脸识别")
  ]),
  /*#__PURE__*/_createElementVNode("li", { class: "explain-mian" }, [
    /*#__PURE__*/_createElementVNode("span", null, "无感通行"),
    /*#__PURE__*/_createTextVNode("极速识别时间")
  ]),
  /*#__PURE__*/_createElementVNode("li", { class: "explain-mian" }, [
    /*#__PURE__*/_createElementVNode("span", null, "超压缩"),
    /*#__PURE__*/_createTextVNode("体积形态")
  ]),
  /*#__PURE__*/_createElementVNode("li", { class: "explain-mian" }, [
    /*#__PURE__*/_createElementVNode("span", null, "全天候全场景"),
    /*#__PURE__*/_createTextVNode("可应用识别")
  ])
], -1))
const _hoisted_77 = { class: "right-con" }
const _hoisted_78 = ["controls"]
const _hoisted_79 = ["controls"]
const _hoisted_80 = {
  key: 2,
  src: _imports_8,
  alt: "",
  class: "stop"
}
const _hoisted_81 = {
  key: 0,
  src: _imports_13,
  alt: "",
  class: "swiper-img"
}
const _hoisted_82 = {
  key: 1,
  src: _imports_14,
  alt: "",
  class: "swiper-img"
}
const _hoisted_83 = { class: "video-swiper-con" }
const _hoisted_84 = { class: "left-con" }
const _hoisted_85 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "crown-con" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_11,
    alt: ""
  }),
  /*#__PURE__*/_createElementVNode("p", { class: "title-one" }, "旗舰产品")
], -1))
const _hoisted_86 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "main-title" }, "VENUS PRO E1", -1))
const _hoisted_87 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "main-title" }, "多光谱人脸+掌静脉+", -1))
const _hoisted_88 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "main-title" }, "大FOV猫眼三合一识别", -1))
const _hoisted_89 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "link" }, "了解更多 >", -1))
const _hoisted_90 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("ul", { class: "explain-con" }, [
  /*#__PURE__*/_createElementVNode("li", { class: "explain-mian" }, [
    /*#__PURE__*/_createElementVNode("span", null, "多光谱生物"),
    /*#__PURE__*/_createTextVNode("识别技术")
  ]),
  /*#__PURE__*/_createElementVNode("li", { class: "explain-mian" }, [
    /*#__PURE__*/_createElementVNode("span", null, "定制"),
    /*#__PURE__*/_createTextVNode("多光谱识别算法")
  ]),
  /*#__PURE__*/_createElementVNode("li", { class: "explain-mian" }, [
    /*#__PURE__*/_createElementVNode("span", null, "自学习AI生物"),
    /*#__PURE__*/_createTextVNode("识别芯片")
  ]),
  /*#__PURE__*/_createElementVNode("li", { class: "explain-mian" }, [
    /*#__PURE__*/_createElementVNode("span", null, "极致性价比"),
    /*#__PURE__*/_createTextVNode("全新三合一光学设计")
  ])
], -1))
const _hoisted_91 = { class: "right-con" }
const _hoisted_92 = ["controls"]
const _hoisted_93 = ["controls"]
const _hoisted_94 = {
  key: 0,
  src: _imports_8,
  alt: "",
  class: "stop"
}
const _hoisted_95 = {
  key: 0,
  src: _imports_16,
  alt: "",
  class: "swiper-img"
}
const _hoisted_96 = {
  key: 1,
  src: _imports_17,
  alt: "",
  class: "swiper-img"
}
const _hoisted_97 = { class: "video-swiper-con" }
const _hoisted_98 = { class: "left-con" }
const _hoisted_99 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "crown-con" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_11,
    alt: ""
  }),
  /*#__PURE__*/_createElementVNode("p", { class: "title-one" }, "旗舰产品")
], -1))
const _hoisted_100 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "main-title" }, "VENUS PRO X", -1))
const _hoisted_101 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "main-title" }, "多光谱人脸+掌静脉+", -1))
const _hoisted_102 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "main-title" }, "微光夜视猫眼三合一识别", -1))
const _hoisted_103 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "link" }, "了解更多 >", -1))
const _hoisted_104 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("ul", { class: "explain-con" }, [
  /*#__PURE__*/_createElementVNode("li", { class: "explain-mian" }, [
    /*#__PURE__*/_createElementVNode("span", null, "微光夜视"),
    /*#__PURE__*/_createTextVNode("大FOV高清猫眼")
  ]),
  /*#__PURE__*/_createElementVNode("li", { class: "explain-mian" }, [
    /*#__PURE__*/_createElementVNode("span", null, "多光谱生物"),
    /*#__PURE__*/_createTextVNode("识别技术")
  ]),
  /*#__PURE__*/_createElementVNode("li", { class: "explain-mian" }, [
    /*#__PURE__*/_createElementVNode("span", null, "定制"),
    /*#__PURE__*/_createTextVNode("多光谱识别算法")
  ]),
  /*#__PURE__*/_createElementVNode("li", { class: "explain-mian" }, [
    /*#__PURE__*/_createElementVNode("span", null, "自学习AI生物"),
    /*#__PURE__*/_createTextVNode("识别芯片")
  ])
], -1))
const _hoisted_105 = { class: "right-con" }
const _hoisted_106 = ["controls"]
const _hoisted_107 = ["controls"]
const _hoisted_108 = {
  key: 0,
  src: _imports_8,
  alt: "",
  class: "stop"
}
const _hoisted_109 = { class: "main-two" }
const _hoisted_110 = { class: "content" }
const _hoisted_111 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "title" }, "应用场景", -1))
const _hoisted_112 = { class: "main-con" }
const _hoisted_113 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "scene-list" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_19,
    alt: "",
    class: "sence-img"
  }),
  /*#__PURE__*/_createElementVNode("p", { class: "tltle" }, "刷脸&刷掌支付"),
  /*#__PURE__*/_createElementVNode("p", { class: "explain" }, [
    /*#__PURE__*/_createTextVNode("金融级安全标准"),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode("安心升级无感支付")
  ])
], -1))
const _hoisted_114 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "scene-list" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_20,
    alt: "",
    class: "sence-img"
  }),
  /*#__PURE__*/_createElementVNode("p", { class: "tltle" }, "机器人3D视觉"),
  /*#__PURE__*/_createElementVNode("p", { class: "explain" }, [
    /*#__PURE__*/_createTextVNode(" 自研业界领先的超广角FOV"),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode("为机器人保驾护航 ")
  ])
], -1))
const _hoisted_115 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "scene-list" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_21,
    alt: "",
    class: "sence-img"
  }),
  /*#__PURE__*/_createElementVNode("p", { class: "tltle" }, "3D刷脸门锁门禁"),
  /*#__PURE__*/_createElementVNode("p", { class: "explain" }, [
    /*#__PURE__*/_createTextVNode("应用金融支付级标准"),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode("让门锁门禁更安全")
  ])
], -1))
const _hoisted_116 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "scene-list" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_22,
    alt: "",
    class: "sence-img"
  }),
  /*#__PURE__*/_createElementVNode("p", { class: "tltle" }, "3D扫描体积视频"),
  /*#__PURE__*/_createElementVNode("p", { class: "explain" }, [
    /*#__PURE__*/_createTextVNode(" 采用自研图形编码算法"),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode("实现工业级超高分辨率 ")
  ])
], -1))
const _hoisted_117 = {
  key: 0,
  class: "contact-main"
}
const _hoisted_118 = { class: "closed" }
const _hoisted_119 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "title" }, "扫码联系我们", -1))
const _hoisted_120 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_23,
  alt: "",
  class: "code"
}, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TopBar = _resolveComponent("TopBar")!
  const _component_ArrowRight = _resolveComponent("ArrowRight")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_el_carousel_item = _resolveComponent("el-carousel-item")!
  const _component_el_carousel = _resolveComponent("el-carousel")!
  const _component_CloseBold = _resolveComponent("CloseBold")!
  const _component_FooterBar = _resolveComponent("FooterBar")!
  const _component_CaretTop = _resolveComponent("CaretTop")!
  const _component_el_backtop = _resolveComponent("el-backtop")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_TopBar),
    _createVNode(_component_el_carousel, {
      height: _ctx.windowWidth >= 800 ? '38vw' : '10.1333rem',
      onChange: _ctx.onCarouselChange,
      "indicator-position": "none",
      "pause-on-hover": true
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_carousel_item, null, {
          default: _withCtx(() => [
            (_ctx.windowWidth >= 800)
              ? (_openBlock(), _createElementBlock("img", _hoisted_2))
              : (_openBlock(), _createElementBlock("img", _hoisted_3)),
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _hoisted_6,
                _hoisted_7,
                _hoisted_8,
                _hoisted_9,
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("div", {
                    class: "tab-one",
                    onClick: _cache[0] || (_cache[0] = ($event: any) => ((_ctx.contactTag = true), _ctx.handleSubmit('SwiperContact-1')))
                  }, " 立即咨询 "),
                  _createVNode(_component_router_link, {
                    to: { name: 'NuwaXPage' },
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.handleSubmit('HomeSwiper-1')))
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_11, [
                        _hoisted_12,
                        _createVNode(_component_el_icon, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_ArrowRight)
                          ]),
                          _: 1
                        })
                      ])
                    ]),
                    _: 1
                  })
                ])
              ])
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_el_carousel_item, null, {
          default: _withCtx(() => [
            (_ctx.windowWidth >= 800)
              ? (_openBlock(), _createElementBlock("img", _hoisted_13))
              : (_openBlock(), _createElementBlock("img", _hoisted_14)),
            _createElementVNode("div", _hoisted_15, [
              _createElementVNode("div", _hoisted_16, [
                _hoisted_17,
                _hoisted_18,
                _hoisted_19,
                _hoisted_20,
                _createElementVNode("div", _hoisted_21, [
                  _createElementVNode("div", {
                    class: "tab-one",
                    onClick: _cache[2] || (_cache[2] = ($event: any) => ((_ctx.contactTag = true), _ctx.handleSubmit('SwiperContact-2')))
                  }, " 立即咨询 "),
                  _createVNode(_component_router_link, {
                    to: { name: 'LitePage' },
                    onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.handleSubmit('HomeSwiper-2')))
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_22, [
                        _hoisted_23,
                        _createVNode(_component_el_icon, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_ArrowRight)
                          ]),
                          _: 1
                        })
                      ])
                    ]),
                    _: 1
                  })
                ])
              ])
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_el_carousel_item, null, {
          default: _withCtx(() => [
            (_ctx.windowWidth >= 800)
              ? (_openBlock(), _createElementBlock("img", _hoisted_24))
              : (_openBlock(), _createElementBlock("img", _hoisted_25)),
            _createElementVNode("div", _hoisted_26, [
              _createElementVNode("div", _hoisted_27, [
                _hoisted_28,
                _hoisted_29,
                _hoisted_30,
                _hoisted_31,
                _createElementVNode("div", _hoisted_32, [
                  _createElementVNode("div", {
                    class: "tab-one",
                    onClick: _cache[4] || (_cache[4] = ($event: any) => ((_ctx.contactTag = true), _ctx.handleSubmit('SwiperContact-2')))
                  }, " 立即咨询 "),
                  _createVNode(_component_router_link, {
                    to: { name: 'LidarPage' },
                    onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.handleSubmit('HomeSwiper-2')))
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_33, [
                        _hoisted_34,
                        _createVNode(_component_el_icon, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_ArrowRight)
                          ]),
                          _: 1
                        })
                      ])
                    ]),
                    _: 1
                  })
                ])
              ])
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_el_carousel_item, null, {
          default: _withCtx(() => [
            (_ctx.windowWidth >= 800)
              ? (_openBlock(), _createElementBlock("img", _hoisted_35))
              : (_openBlock(), _createElementBlock("img", _hoisted_36)),
            _createElementVNode("div", _hoisted_37, [
              _createElementVNode("div", _hoisted_38, [
                _hoisted_39,
                _hoisted_40,
                _hoisted_41,
                _hoisted_42,
                _createElementVNode("div", _hoisted_43, [
                  _createElementVNode("div", {
                    class: "tab-one",
                    onClick: _cache[6] || (_cache[6] = ($event: any) => ((_ctx.contactTag = true), _ctx.handleSubmit('SwiperContact-2')))
                  }, " 立即咨询 "),
                  _createVNode(_component_router_link, {
                    to: { name: 'Venus-LiteX' },
                    onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.handleSubmit('HomeSwiper-3')))
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_44, [
                        _hoisted_45,
                        _createVNode(_component_el_icon, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_ArrowRight)
                          ]),
                          _: 1
                        })
                      ])
                    ]),
                    _: 1
                  })
                ])
              ])
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_el_carousel_item, null, {
          default: _withCtx(() => [
            (_ctx.windowWidth >= 800)
              ? (_openBlock(), _createElementBlock("img", _hoisted_46))
              : (_openBlock(), _createElementBlock("img", _hoisted_47)),
            _createElementVNode("div", _hoisted_48, [
              _createElementVNode("div", _hoisted_49, [
                _hoisted_50,
                _hoisted_51,
                _hoisted_52,
                _hoisted_53,
                _createElementVNode("div", _hoisted_54, [
                  _createElementVNode("div", {
                    class: "tab-one",
                    onClick: _cache[8] || (_cache[8] = ($event: any) => ((_ctx.contactTag = true), _ctx.handleSubmit('SwiperContact-2')))
                  }, " 立即咨询 "),
                  _createVNode(_component_router_link, {
                    to: { name: 'Nuwa-Lidar120' },
                    onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.handleSubmit('HomeSwiper-4')))
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_55, [
                        _hoisted_56,
                        _createVNode(_component_el_icon, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_ArrowRight)
                          ]),
                          _: 1
                        })
                      ])
                    ]),
                    _: 1
                  })
                ])
              ])
            ])
          ]),
          _: 1
        }),
        _createElementVNode("div", _hoisted_57, [
          _createElementVNode("div", {
            class: _normalizeClass(["initial-index", _ctx.carouselIndex == 0 ? 'initial-active' : ''])
          }, null, 2),
          _createElementVNode("div", {
            class: _normalizeClass(["initial-index", _ctx.carouselIndex == 1 ? 'initial-active' : ''])
          }, null, 2),
          _createElementVNode("div", {
            class: _normalizeClass(["initial-index", _ctx.carouselIndex == 2 ? 'initial-active' : ''])
          }, null, 2)
        ])
      ]),
      _: 1
    }, 8, ["height", "onChange"]),
    _createElementVNode("div", _hoisted_58, [
      _createVNode(_component_el_carousel, {
        height: _ctx.windowWidth >= 800 ? '32.8vw' : '12.4267rem',
        "indicator-position": "none",
        "pause-on-hover": true,
        autoplay: _ctx.autoplay
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_carousel_item, null, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_59, [
                _createElementVNode("div", _hoisted_60, [
                  _createElementVNode("p", _hoisted_61, [
                    _createTextVNode("3D感测"),
                    (_ctx.windowWidth >= 800)
                      ? (_openBlock(), _createElementBlock("br", _hoisted_62))
                      : _createCommentVNode("", true),
                    _createTextVNode("赋能万千终端")
                  ]),
                  _hoisted_63
                ]),
                _createElementVNode("div", _hoisted_64, [
                  _createElementVNode("div", {
                    class: "video-con",
                    onMouseenter: _cache[14] || (_cache[14] = ($event: any) => (_ctx.ovevVideo()))
                  }, [
                    (_ctx.windowWidth >= 800)
                      ? (_openBlock(), _createElementBlock("video", {
                          key: 0,
                          preload: "auto",
                          width: "770",
                          height: "470",
                          autoplay: false,
                          controls: _ctx.videoTag,
                          src: "http://134.175.230.209:9000/website/20221110/video/video.mp4",
                          onPlay: _cache[10] || (_cache[10] = ($event: any) => (_ctx.handleVideoPlay())),
                          onPause: _cache[11] || (_cache[11] = ($event: any) => (_ctx.handleVideoPause()))
                        }, null, 40, _hoisted_65))
                      : (_openBlock(), _createElementBlock("video", {
                          key: 1,
                          preload: "auto",
                          width: "304",
                          height: "172",
                          autoplay: false,
                          controls: _ctx.videoTag,
                          src: "http://134.175.230.209:9000/website/20221110/video/video.mp4",
                          onPlay: _cache[12] || (_cache[12] = ($event: any) => (_ctx.handleVideoPlay())),
                          onPause: _cache[13] || (_cache[13] = ($event: any) => (_ctx.handleVideoPause()))
                        }, null, 40, _hoisted_66)),
                    (!_ctx.videoTag)
                      ? (_openBlock(), _createElementBlock("img", _hoisted_67))
                      : _createCommentVNode("", true)
                  ], 32)
                ])
              ])
            ]),
            _: 1
          }),
          _createVNode(_component_el_carousel_item, null, {
            default: _withCtx(() => [
              (_ctx.windowWidth >= 800)
                ? (_openBlock(), _createElementBlock("img", _hoisted_68))
                : (_openBlock(), _createElementBlock("img", _hoisted_69)),
              _createElementVNode("div", _hoisted_70, [
                _createElementVNode("div", _hoisted_71, [
                  _hoisted_72,
                  _hoisted_73,
                  _hoisted_74,
                  _createVNode(_component_router_link, {
                    to: { name: 'Venus-LiteS' },
                    onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.handleSubmit('HomeSwiper-2')))
                  }, {
                    default: _withCtx(() => [
                      _hoisted_75
                    ]),
                    _: 1
                  }),
                  _hoisted_76
                ]),
                _createElementVNode("div", _hoisted_77, [
                  _createElementVNode("div", {
                    class: "video-con",
                    onMouseenter: _cache[20] || (_cache[20] = ($event: any) => (_ctx.ovevVideo()))
                  }, [
                    (_ctx.windowWidth >= 800)
                      ? (_openBlock(), _createElementBlock("video", {
                          key: 0,
                          preload: "auto",
                          width: "770",
                          height: "470",
                          autoplay: false,
                          controls: _ctx.videoTag,
                          src: _imports_12,
                          onPlay: _cache[16] || (_cache[16] = ($event: any) => (_ctx.handleVideoPlay())),
                          onPause: _cache[17] || (_cache[17] = ($event: any) => (_ctx.handleVideoPause()))
                        }, null, 40, _hoisted_78))
                      : (_openBlock(), _createElementBlock("video", {
                          key: 1,
                          preload: "auto",
                          width: "304",
                          height: "172",
                          autoplay: false,
                          controls: _ctx.videoTag,
                          src: _imports_12,
                          onPlay: _cache[18] || (_cache[18] = ($event: any) => (_ctx.handleVideoPlay())),
                          onPause: _cache[19] || (_cache[19] = ($event: any) => (_ctx.handleVideoPause()))
                        }, null, 40, _hoisted_79)),
                    (!_ctx.videoTag)
                      ? (_openBlock(), _createElementBlock("img", _hoisted_80))
                      : _createCommentVNode("", true)
                  ], 32)
                ])
              ])
            ]),
            _: 1
          }),
          _createVNode(_component_el_carousel_item, null, {
            default: _withCtx(() => [
              (_ctx.windowWidth >= 800)
                ? (_openBlock(), _createElementBlock("img", _hoisted_81))
                : (_openBlock(), _createElementBlock("img", _hoisted_82)),
              _createElementVNode("div", _hoisted_83, [
                _createElementVNode("div", _hoisted_84, [
                  _hoisted_85,
                  _hoisted_86,
                  _hoisted_87,
                  _hoisted_88,
                  _createVNode(_component_router_link, {
                    to: { name: 'Venus-ProE1' },
                    onClick: _cache[21] || (_cache[21] = ($event: any) => (_ctx.handleSubmit('HomeSwiper-2')))
                  }, {
                    default: _withCtx(() => [
                      _hoisted_89
                    ]),
                    _: 1
                  }),
                  _hoisted_90
                ]),
                _createElementVNode("div", _hoisted_91, [
                  _createElementVNode("div", {
                    class: "video-con",
                    onMouseenter: _cache[26] || (_cache[26] = ($event: any) => (_ctx.ovevVideo()))
                  }, [
                    (_ctx.windowWidth >= 800)
                      ? (_openBlock(), _createElementBlock("video", {
                          key: 0,
                          preload: "auto",
                          width: "770",
                          height: "470",
                          autoplay: false,
                          controls: _ctx.videoTag,
                          src: _imports_15,
                          onPlay: _cache[22] || (_cache[22] = ($event: any) => (_ctx.handleVideoPlay())),
                          onPause: _cache[23] || (_cache[23] = ($event: any) => (_ctx.handleVideoPause()))
                        }, null, 40, _hoisted_92))
                      : (_openBlock(), _createElementBlock("video", {
                          key: 1,
                          preload: "auto",
                          width: "304",
                          height: "172",
                          autoplay: false,
                          controls: _ctx.videoTag,
                          src: _imports_15,
                          onPlay: _cache[24] || (_cache[24] = ($event: any) => (_ctx.handleVideoPlay())),
                          onPause: _cache[25] || (_cache[25] = ($event: any) => (_ctx.handleVideoPause()))
                        }, null, 40, _hoisted_93))
                  ], 32),
                  (!_ctx.videoTag)
                    ? (_openBlock(), _createElementBlock("img", _hoisted_94))
                    : _createCommentVNode("", true)
                ])
              ])
            ]),
            _: 1
          }),
          _createVNode(_component_el_carousel_item, null, {
            default: _withCtx(() => [
              (_ctx.windowWidth >= 800)
                ? (_openBlock(), _createElementBlock("img", _hoisted_95))
                : (_openBlock(), _createElementBlock("img", _hoisted_96)),
              _createElementVNode("div", _hoisted_97, [
                _createElementVNode("div", _hoisted_98, [
                  _hoisted_99,
                  _hoisted_100,
                  _hoisted_101,
                  _hoisted_102,
                  _createVNode(_component_router_link, {
                    to: { name: 'Venus-ProX' },
                    onClick: _cache[27] || (_cache[27] = ($event: any) => (_ctx.handleSubmit('HomeSwiper-2')))
                  }, {
                    default: _withCtx(() => [
                      _hoisted_103
                    ]),
                    _: 1
                  }),
                  _hoisted_104
                ]),
                _createElementVNode("div", _hoisted_105, [
                  _createElementVNode("div", {
                    class: "video-con",
                    onMouseenter: _cache[32] || (_cache[32] = ($event: any) => (_ctx.ovevVideo()))
                  }, [
                    (_ctx.windowWidth >= 800)
                      ? (_openBlock(), _createElementBlock("video", {
                          key: 0,
                          preload: "auto",
                          width: "770",
                          height: "470",
                          autoplay: false,
                          controls: _ctx.videoTag,
                          src: _imports_18,
                          onPlay: _cache[28] || (_cache[28] = ($event: any) => (_ctx.handleVideoPlay())),
                          onPause: _cache[29] || (_cache[29] = ($event: any) => (_ctx.handleVideoPause()))
                        }, null, 40, _hoisted_106))
                      : (_openBlock(), _createElementBlock("video", {
                          key: 1,
                          preload: "auto",
                          width: "304",
                          height: "172",
                          autoplay: false,
                          controls: _ctx.videoTag,
                          src: _imports_18,
                          onPlay: _cache[30] || (_cache[30] = ($event: any) => (_ctx.handleVideoPlay())),
                          onPause: _cache[31] || (_cache[31] = ($event: any) => (_ctx.handleVideoPause()))
                        }, null, 40, _hoisted_107))
                  ], 32),
                  (!_ctx.videoTag)
                    ? (_openBlock(), _createElementBlock("img", _hoisted_108))
                    : _createCommentVNode("", true)
                ])
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["height", "autoplay"])
    ]),
    _createElementVNode("div", _hoisted_109, [
      _createElementVNode("div", _hoisted_110, [
        _hoisted_111,
        _createElementVNode("div", _hoisted_112, [
          _createVNode(_component_router_link, {
            to: { name: 'PaymentPage' },
            onClick: _cache[33] || (_cache[33] = ($event: any) => (_ctx.handleSubmit('PaymentPage')))
          }, {
            default: _withCtx(() => [
              _hoisted_113
            ]),
            _: 1
          }),
          _createVNode(_component_router_link, {
            to: { name: 'RobotPage' },
            onClick: _cache[34] || (_cache[34] = ($event: any) => (_ctx.handleSubmit('RobotPage')))
          }, {
            default: _withCtx(() => [
              _hoisted_114
            ]),
            _: 1
          }),
          _createVNode(_component_router_link, {
            to: { name: 'LockPage' },
            onClick: _cache[35] || (_cache[35] = ($event: any) => (_ctx.handleSubmit('LockPage')))
          }, {
            default: _withCtx(() => [
              _hoisted_115
            ]),
            _: 1
          }),
          _createVNode(_component_router_link, {
            to: { name: 'MeasurePage' },
            onClick: _cache[36] || (_cache[36] = ($event: any) => (_ctx.handleSubmit('MeasurePage')))
          }, {
            default: _withCtx(() => [
              _hoisted_116
            ]),
            _: 1
          })
        ])
      ])
    ]),
    (_ctx.contactTag)
      ? (_openBlock(), _createElementBlock("div", _hoisted_117, [
          _createElementVNode("div", _hoisted_118, [
            _createVNode(_component_el_icon, {
              color: "#FFFFFF",
              size: "18px",
              onClick: _cache[37] || (_cache[37] = ($event: any) => (_ctx.contactTag = false))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_CloseBold)
              ]),
              _: 1
            })
          ]),
          _hoisted_119,
          _hoisted_120
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_FooterBar),
    (_ctx.windowWidth >= 800)
      ? (_openBlock(), _createBlock(_component_el_backtop, {
          key: 1,
          "visibility-height": 500,
          right: 30,
          bottom: 30
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_icon, {
              color: "#999999",
              size: "25px"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_CaretTop)
              ]),
              _: 1
            })
          ]),
          _: 1
        }))
      : _createCommentVNode("", true)
  ]))
}